import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { omit } from 'lodash-es'
import { useSnackbars } from 'settle-ui/hooks/useSnackbars/useSnackbars'
import { openSupportContact } from 'routes/helpers/openSupportContact/openSupportContact'

export const useExistingVendorWarning = () => {
  const router = useRouter()
  const { showWarning } = useSnackbars()
  const { t } = useTranslation()

  useEffect(() => {
    if (router.query.existing_vendor === 'true') {
      showWarning(t('vendorBusinessAlreadyExists::title'), {
        'data-testid': 'login-page_business-exists-warning-text',
        text: t('vendorBusinessAlreadyExists::button'),
        onClick: () => openSupportContact(),
      })

      router.push({ query: omit(router.query, 'existing_vendor') })
    }
  }, [router, t, showWarning])
}
